import type { HighlightRealEstate } from '@dreamstack/accentro-contentful/src/blocks/HighlightRealEstate'
import { useLocale } from '@dreamstack/i18n'
import filter from 'lodash/filter'
import map from 'lodash/map'
import type { FunctionComponent, ReactElement } from 'react'
import { useMemo } from 'react'
import type { ComingSoonPreview } from '../projects/ComingSoonPreview'
import type { ProjectPreview } from '../projects/ProjectPreview'

const projectWrapperClass = 'w-full'
const projectWrapperLeftClass = 'md:pr-px-24 lg:pr-px-32'
const projectWrapperRightClass = 'md:pl-px-24 lg:pl-px-32'
const rowClass = 'w-1/2 space-y-px-64 md:space-y-px-128'

export const ProjectPreviewLayout: FunctionComponent<{
  children: ReactElement<
    | typeof ComingSoonPreview
    | typeof ProjectPreview
    | typeof HighlightRealEstate
  >[]
}> = ({ children }) => {
  const locale = useLocale()

  const leftRow = useMemo(
    () => filter(children, (_item, i) => i % 2 === 0),
    [children]
  )
  const rightRow = useMemo(
    () => filter(children, (_item, i) => i % 2 === 1),
    [children]
  )

  return (
    <>
      <div className="space-y-px-64 md:hidden">
        {map(children, (project) => (
          <div className={projectWrapperClass} key={`${project.key}${locale}`}>
            {project}
          </div>
        ))}
      </div>
      <div className="hidden md:flex">
        <div className={rowClass}>
          {map(leftRow, (project) => (
            <div
              className={`${projectWrapperClass} ${projectWrapperLeftClass}`}
              key={`${project.key}${locale}`}
            >
              {project}
            </div>
          ))}
        </div>
        <div className={`${rowClass} pt-px-128`}>
          {map(rightRow, (project) => (
            <div
              className={`${projectWrapperClass} ${projectWrapperRightClass}`}
              key={`${project.key}${locale}`}
            >
              {project}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
